import * as yup from "yup";

import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";

export const fetchClinicActivitiesPeriods = async (): Promise<
  ApiResponse<ClinicActivitiesPeriodsDto[]>
> => {
  const response = await fetchData(
    "/dietitian/clinic/activities-periods",
    APIMethods.GET,
    undefined,
  );

  return await fetchClinicActivitiesPeriodsSchema.validate(response);
};

export interface ClinicActivitiesPeriodsDto {
  start: string;
  end: string;
}

const clinicActivityPeriodSchema = yup.object().shape({
  start: yup.string().required(),
  end: yup.string().required(),
});

const fetchClinicActivitiesPeriodsSchema = yup.object().shape({
  data: yup.array().of(clinicActivityPeriodSchema).required(),
});
